import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {IYear} from "../../../../../data/data";
import {getYearData} from '../../../../../store/reducers/year';
import {allDamagedStationsRepaired, isYearAlreadyComplete, isYearComplete} from '../../../../../store/reducers/calendar/isYearAlreadyComplete';

interface Props
{
    year: IYear;
    year_complete: boolean;
    all_damage_repaired: boolean;
}

import './YearEnd.scss';


class YearEnd extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    getText = () : string =>
    {
        const {year:year_obj, year_complete, all_damage_repaired} = this.props;
        const {'year-end':year_end, 'year-end-success':year_end_success, 'year-end-fail':year_end_fail} = year_obj;

        console.group('getText');
        console.log('year_end_success', year_end_success);
        console.log('all_damage_repaired', all_damage_repaired);
        console.log('year_complete', year_complete);
        console.groupEnd();

        if (year_end_success)
        {
            return (year_complete || all_damage_repaired) ? year_end_success : year_end_fail;
        }

        return year_end;
    };


    render()
    {
        return <div styleName={'year-end'}>

            <div styleName={'text-column'}>

                <p
                    styleName={'body-copy'}
                    dangerouslySetInnerHTML={{ __html: this.getText() }} />

            </div>

        </div>;
    }
}


const mapStateToProps = state =>
{
    return {
        // season: getSeasonData(state)
        year: getYearData(state),
        year_complete: isYearComplete(state),
        all_damage_repaired: allDamagedStationsRepaired(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(YearEnd);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/year-end/YearEnd.tsx